'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('violations-ticket-show', {
      url: '/violation/ticket/detail/:id',
      template: '<violations-ticket-show></violations-ticket-show>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/violations/ticket-show/violations-ticket-show.routes.js